import { Request, BaseApiUrl, postExportExcel } from "./api";

const url = `${BaseApiUrl}/api/Common`;

export const updateUserInfo = (parmas) => {
  return Request.post(`${url}/UpdateUserInfo`, parmas);
};

// HTML-导出
export const ExportExcel = (params, title) => {
  return postExportExcel(`${BaseApiUrl}/api/Command/ExportExcel`, params, title);
};